import type { RefObject } from 'react';
import { useEffect } from 'react';
import { select } from 'd3-selection';

/**
 * d3 で mousedownのコールバックを利用するためのフック
 * @param ref mousedownイベントを受け取りたいHTML/SVG要素のref
 * @param onMouseDown イベントハンドラ
 * @param stopPropagation イベント伝搬を停止するか否かを決めるbool値
 */
export const useD3MouseDownCallback = <T extends HTMLElement | SVGElement>(
  ref: RefObject<T | null>,
  onMouseDown: () => void,
  stopPropagation = false
): void => {
  useEffect(() => {
    const dom = ref.current;
    select(dom).on('mousedown', (event: MouseEvent) => {
      if (stopPropagation) {
        event.stopPropagation();
      }
      onMouseDown();
    });

    return () => {
      select(dom).on('mousedown', null);
    };
  }, [ref, onMouseDown, stopPropagation]);
};
